import { Button } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import UberEatsConnectCard from "./UberEatsConnectCard";

export default function UberEatsOnboarding({ handleShowOptions }) {
  return (
    <UberEatsConnectCard>
      <p className={styles.dsFormLabels}>
        Get started by tapping '<b>Connect to UberEats</b>' and filling out the
        required form to enable delivery for your store. Make sure all
        information is accurate, as processing can take up to 24 hours or
        longer.
      </p>
      <br />
      <Button
        block
        type="primary"
        className={styles.dsLargeButton}
        onClick={handleShowOptions}
      >
        <p>CONNECT TO UBEREATS</p>
      </Button>
    </UberEatsConnectCard>
  );
};